export const expertRoutes = [
    {
        path: '/expert/:id',
        component: () => import(/* webpackChunkName: "expert" */ '@/views/expert/index.vue'),
        meta: {
            title: '好医术'
        }
    },
    {
        path: '/expert/:type/:id',
        component: () => import(/* webpackChunkName: "expert" */ '@/views/expert/course.vue'),
        meta: {
            title: '好医术'
        }
    }
];
